function initializeNavigationSwitcher(sectionElement) {
  if (!sectionElement) return;

  const links = sectionElement.querySelectorAll('.navigation_switcher__link');
  if (!links || links.length === 0) return;

  const currentUrl = window.location.href;

  for (const link of links) {
    if (currentUrl.includes(link.dataset.link)) {
      link.classList.add('active');
    }
  }
}

function setupNavigation() {
    const sectionsToInitialize = document.querySelectorAll('[data-section-script="navigation-switcher"]');
    sectionsToInitialize.forEach((section) => {
        initializeNavigationSwitcher(section);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupNavigation);
} else {
    setupNavigation();
}